module.exports = __webpack_public_path__ + "static/img/oregon-coast-wayside-signs08.8e1747a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/oregon/oregon-coast-wayside-signs08.jpg
// module id = 871
// module chunks = 0